import { Http } from '../../../support';

const initialState = {
  data: {},
  busy: false,
};

const cancel = async (store, uuids, meta = {}) => {
  store.setState((state) => {
    state.app.comprobantes.cancel.busy = true;
  });

  try {
    const body = {
      action: 'cancel',
      data: uuids || undefined,
    };

    let response;

    if (meta.uuid) {
      response = await Http.patch(`api/comprobantes/${meta.uuid}`, {
        ...body,
        ...meta,
      });
    } else {
      response = await Http.patch(`api/comprobantes`, body);
    }

    store.setState((state) => {
      state.app.comprobantes.cancel.busy = false;
      state.app.comprobantes.cancel.data = response.data;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.app.comprobantes.cancel.busy = false;
      state.app.comprobantes.cancel.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.comprobantes.cancel = { ...initialState };
  });
};

const ComprobanteCancellationStore = {
  state: () => initialState,
  actions: {
    cancel,
    reset,
  },
};

export default ComprobanteCancellationStore;
